export const css = {
    underlay: '_1HdXsYdI',
    paneFixed: '_1Ln93RFy',
    contentFixed: '_3dMk_dO8',
    leftFixed: 'rVXYMK7M',
    rightFixed: '_1DsKoFmb',
    topFixed: '_1c93c8bk',
    bottomFixed: '_1pSn6kb4',
    ' _key': 'base-widgets/sliding-pane-fixed'
};
export default css;
